<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <NeList ref='neList' :neArr='netype' :select='neClick'></NeList>
    </template>
    <template v-slot:right_view>
      <SpecialDataTableMenu @methodEnum='methodEnum'></SpecialDataTableMenu>
      <SpecialDataTable ref="specialdataTable"></SpecialDataTable>
    </template>
  </BasicLayout>
</template>

<script>
import SpecialDataTable from '../../../../components/subscriberconfig/udmSubscriber/specialdata/SpecialDataTable';
import SpecialDataTableMenu from '../../../../components/subscriberconfig/udmSubscriber/specialdata/SpecialDataTableMenu';
import BasicLayout from '../../../../layouts/BasicLayout';
import NeList from '../../../../components/common/NeListNoIP';

export default {
  name: 'SpecialDataMainPage',
  components: {
    NeList,
    SpecialDataTable,
    SpecialDataTableMenu,
    BasicLayout,
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t("Profile.nelist"),
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: this.$t("SpecialData.crumb"),
      },
      netype: [36],
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'add':
          this.$refs.specialdataTable.openAddProfilePage();
          break;
        case 'mod':
          this.$refs.specialdataTable.openModProfilePage();
          break;
        case 'del':
          this.$refs.specialdataTable.delProfiles();
          break;
        case 'qry':
          this.$refs.specialdataTable.qryProfiles(true);
          break;
        default:
      }
    },
    neClick() {
      this.$refs.specialdataTable.getGridData(this.$refs.neList.getNe());
    }
  }
};
</script>

<style scoped>

</style>
